import { send } from '../../../src/network';
import { type ServingSize } from '../../../src/types/PlanServicePlanComponents';

export type RecipeSize = 2 | 4;
type BreakfastPacks = 0 | 1 | 2 | 3;
type SnackPacks = 0 | 1 | 2 | 3;
type SweetPacks = 0 | 1 | 2 | 3;
type KidsSnackPacks = 0 | 1 | 2 | 3;

export enum PromoType {
  FLAT_DISCOUNT,
  PERCENT_DISCOUNT,
  FREE_SHIPPING,
  // check if this exists
  FREE_ITEM,
  REFERRAL_DISCOUNT,
  FREE_ITEM_FOR_LIFE,
}

// there will be a v2
export interface PromosV1 {
  code: string;
  type: PromoType;
  value: number;
  is_expired: boolean;
  effect: string;
  threshold: number | string;
}
export interface PricingConfig {
  version: number;
  first_box_total_with_shipping_and_credit: number;
  first_box_potential_credit: number;
  breakfastPacks: BreakfastPacks;
  numLunch: number;
  numDinner: number;
  snackPacks: SnackPacks;
  sweetsPacks: SweetPacks;
  fruitPacks: number;
  servingSize: ServingSize;
  kidSnackPacks: KidsSnackPacks;
  shipping: number;
  allow4Servings: boolean;
  firstBoxTotal: number;
  subtotal: number;
  price_per_serving: number;
  promo_effect: {
    promos: Array<PromosV1>;
    free_item_effect: string;
    discount_effect: string;
    effect_str: string;
    effect_base: string;
  };
  household_size: number | null;
  discount_per_delivery_pct: number;
  discount_per_delivery_amount: number;
  firstBoxDiscount: number;
  max_price_per_serving: number;
  discount_per_meal: number;
}

export const getPricingConfigPath = () => {
  return '/api/get_pricing_config/';
};

export async function getPricingConfigRequest() {
  return await send<PricingConfig>({
    method: 'GET',
    path: getPricingConfigPath(),
  });
}
